/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClientsControllerUpdateMutationRequest, ClientsControllerUpdateMutationResponse, ClientsControllerUpdatePathParams, ClientsControllerUpdate400, ClientsControllerUpdate401, ClientsControllerUpdate403, ClientsControllerUpdate404 } from "../../models/clientsController/ClientsControllerUpdate";

function getClientsControllerUpdateUrl(id: ClientsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/clients/${id}` as const }  
  return res
}

/**
 * @summary Update a client
 * {@link /api/v1/clients/:id}
 */
export async function clientsControllerUpdate(id: ClientsControllerUpdatePathParams["id"], data?: ClientsControllerUpdateMutationRequest, config: Partial<RequestConfig<ClientsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ClientsControllerUpdateMutationResponse, ResponseErrorConfig<ClientsControllerUpdate400 | ClientsControllerUpdate401 | ClientsControllerUpdate403 | ClientsControllerUpdate404>, ClientsControllerUpdateMutationRequest>({ method : "PATCH", url : getClientsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}